import React, { useEffect, useState } from 'react';
import '../../admin/asset/asset.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { Grid } from '@material-ui/core';
import AgGridContainer from '../../../componant/gridContainer/gridContainer';
import { getEmployeeAssets } from '../../../api-services/employee-services';
import { AssetModel } from '../../../model/asset-model/asset.model';
import { SnackbarService } from '../../../services/snackBehaviorSubject/snackBehaviorSubject';
import { TokenService } from '../../../services/token.service';

const UserAsset = () => {
    const snackbarService = SnackbarService();
    const [rowData, setRowData] = useState<AssetModel[]>([]);

    const fetchData = () => {
        const token = TokenService.extractToken();
        const employeeId = token?.employee_id;

        if (!employeeId) {
            snackbarService.next({ data: { open: true, severity: 'error', message: 'Employee ID not found' } });
            return;
        }

        getEmployeeAssets(employeeId).then((response: any) => {
            if (response && response.data) {
                if (response.data.success && response.data.payload) {
                    setRowData(response.data.payload);
                } else if (Array.isArray(response.data)) {
                    setRowData(response.data);
                } else if (response.data.payload) {
                    setRowData(response.data.payload);
                } else {
                    setRowData([]);
                }
            } else {
                setRowData([]);
            }
        }).catch((err: any) => {
            console.error("Error fetching employee assets: ", err);
            snackbarService.next({ data: { open: true, severity: 'error', message: 'Failed to fetch asset data' } });
            setRowData([]);
        });
    };

    useEffect(() => {
        fetchData();
    }, []);

    const [columnDefs] = useState<any[]>([
        {
            headerName: "ID",
            field: "id",
            resizable: true,
            filter: true,
            flex: 0.5
        },
        {
            headerName: "Asset Name",
            field: "assetName",
            resizable: true,
            filter: true,
            flex: 1
        },
        {
            headerName: "Asset Type",
            field: "assetType",
            resizable: true,
            filter: true,
            flex: 1
        },
        {
            headerName: "Brand",
            field: "brand",
            resizable: true,
            filter: true,
            flex: 1
        },
        {
            headerName: "Model",
            field: "model",
            resizable: true,
            filter: true,
            flex: 1
        },
        {
            headerName: "Serial Number",
            field: "serialNumber",
            resizable: true,
            filter: true,
            flex: 1
        },
        {
            headerName: "Status",
            field: "status",
            resizable: true,
            filter: true,
            flex: 1
        },
        {
            headerName: "Requisition Date",
            field: "assetRequisitionDate",
            resizable: true,
            filter: true,
            flex: 1,
            cellRenderer: (params: any) => {
                return params.value ? params.value : "N/A";
            }
        },
        {
            headerName: "Return Date",
            field: "assetReturnDate",
            resizable: true,
            filter: true,
            flex: 1,
            cellRenderer: (params: any) => {
                return params.value ? params.value : "N/A";
            }
        }
    ]);

    return (
        <div className='main'>
            <div className='main-container'>
                <div className='heading heading-center-space-between height-40'>
                    <Grid container>
                        <Grid item xs={12} className='flex-start-center'>
                            <h2>My Assets</h2>
                        </Grid>
                    </Grid>
                </div>
                <div className='sub-container cal-40'>
                    <Grid item style={{ height: '100%' }}>
                        <div className='asset-container'>
                            <AgGridContainer rowData={rowData} columnDefs={columnDefs} />
                        </div>
                    </Grid>
                </div>
            </div>
        </div>
    );
};

export default UserAsset;
